<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import CardLimitMixin from "../../../author/pagesbuilder/mixins/CardLimitMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import PromotionsMixin from "../../../author/pagesbuilder/mixins/PromotionsMixin";
    import FiltersMixin from "../../../author/pagesbuilder/mixins/FiltersMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";
    import { debounce } from 'lodash';

    export default {
        name : "CourseCardsComponent",
        data () {
            return {
                componentType: "course-cards",
                currentRenderData : {},
                courseAccessKeys : {
                    'view-locked' : 'private',
                    'private' : 'draft',
                    'private-enroll': 'enrollment-closed',
                    'soon': 'soon',
                    'public': ['free','paid']
                },
                courseStatusKeys: {
                    'paid': 'paid',
                    'free': 'free'
                }
            }
        },
        mixins: [
            FiltersMixin,
            RowsMixin,
            PromotionsMixin,
            SliderMixin,
            CardLimitMixin
        ],
        mounted () {
            this.debouncedRenderComponent();
        },
        computed: {
            ...mapState([                
                'subscriptionMode',
                'courseContinue',
                'billing',
                'mobileSettings'
            ]),
            ...mapState('products', [
                "courses",
                "bundles",
                "subscriptions",
                "productPricesForCoupon",
            ]),
            ...mapState('pages', [
                'isAfterLoginPage',
                'isAfterPurchasePage'
            ]),
            ...mapGetters('products',[
                'courseAuthors',
                'courseCategories'
            ]),
            ...mapGetters('user', [
                'isLoggedIn',
                'isAdmin'
            ]),
            availableCards () {
                return [
                    {
                        cardFilename : "coursecard1",
                        forSectionTemplates: ["Courses1", "Courses11"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard1.png"
                    },
                    {
                        cardFilename : "coursecard1-2",
                        forSectionTemplates: ["Courses4"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard1-2.png"
                    },
                    {
                        cardFilename : "coursecard1-3",
                        forSectionTemplates: ["Courses2"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard1-3.png"
                    },
                    {
                        cardFilename : "coursecard2",
                        forSectionTemplates: ["Courses7", "tpl-bundle-contents-1"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard2.png"
                    },
                    {
                        cardFilename : "coursecard2-2",
                        forSectionTemplates: [],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard2-2.png"
                    },
                    {
                        cardFilename : "coursecard2-3",
                        forSectionTemplates: ["Courses8"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard2-3.png"
                    },
                    {
                        cardFilename : "coursecard3",
                        forSectionTemplates: ["courses9"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard3.png"
                    },
                    {
                        cardFilename : "coursecard3-2",
                        forSectionTemplates: [],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard3-2.png"
                    },
                    {
                        cardFilename : "coursecard3-3",
                        forSectionTemplates: ["courses10"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard3-3.png"
                    },
                    {
                        cardFilename : "coursecard4",
                        forSectionTemplates: ["Courses3"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard4.png"
                    },
                    {
                        cardFilename : "coursecard4-2",
                        forSectionTemplates: [],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard4-2.png"
                    },
                    {
                        cardFilename : "coursecard4-3",
                        forSectionTemplates: ["Courses5", "Courses6"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard4-3.png"
                    },
                    {
                        cardFilename : "coursecard-for-list",
                        forSectionTemplates: ["tpl-bundle-contents-2","tpl-subscription-contents-2"],
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/courses8.jpg",
                        hideFromCardsSlider: true
                    }
                ]
            },
            availableFilterTemplates () {
                return [
                    {
                        templateFilename : "CourseCardsFilters1",
                        forSectionTemplates: ["Courses1","Courses2"],
                    },
                    {
                        templateFilename : "CourseCardsFilters2",
                        forSectionTemplates: ["Courses4"],
                    },
                    {
                        templateFilename : "CourseCardsFilters3",
                        forSectionTemplates: ["Courses6"],
                    },
                    {
                        templateFilename : "CourseCardsFilters4",
                        forSectionTemplates: ["Courses5"],
                    },
                    {
                        templateFilename : "CourseCardsFilters5",
                        forSectionTemplates: ["Courses3"],
                    },
                    {
                        templateFilename : "CourseCardsFilters6",
                        forSectionTemplates: ["Courses11"],
                    },
                    {
                        templateFilename : "CourseCardsFiltersInSidebar",
                        forSectionTemplates: ["Courses9","Courses10"],
                    }
                ]
            },
            contextWrapper () {
                return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.$t('blog.load_more'),
                        display: this.currentRenderData.data && (this.currentRenderData.rows * this.currentRenderData.cardsPerRow < this.currentRenderData.data.length),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    }
                ]
            },
            getFiltersParams () {
                return {
                    filterLayout: this.getDefaultFiltersTemplate,
                    selectedPrimaryFilter : this.getPrimaryFilter,
                    selectedSecondaryFilter : this.getSecondaryFilter,
                    showFilters : this.getFiltersDisplay,
                    searchTermValue: this.getPrimaryFilter === 'bySearchTerm' && this.getSecondaryFilter ? this.getSecondaryFilter : ""
                }
            },
            getDefaultFiltersTemplate () {
                let defaultFilter = this.availableFilterTemplates[0].templateFilename;
                let sectionState = this.findNodeState(this.sectionId);
                if (!sectionState) {
                    return defaultFilter
                }

                let sectionTemplateId = sectionState.sectionTemplateId;
                let filterTemplate = this.availableFilterTemplates.find(filterTemplate => filterTemplate.forSectionTemplates.includes(sectionTemplateId));

                return filterTemplate ? filterTemplate.templateFilename : defaultFilter;
            },
            availableSubscriptions () {
                return this.subscriptions.filter(subscription => subscription.access === 'public');
            },
            availableBundles () {
                return this.bundles.filter(bundle => bundle.access === 'public');
            },
            availableCourses () {
                return this.courses.filter(course => course.access === 'public' || course.access === 'soon');
            },
            getFiltersConfig () {
                return [
                    {
                        filteringKey: "byAll",
                        filteringFunction: null,
                        filterAvailable: true,
                        label: "All",
                        translatedLabel: this.translations.filter_all
                    },
                    {
                        filteringKey: "byMyCourses",
                        filteringFunction: this.filterCoursesByMyCourses,
                        filterAvailable: this.isLoggedIn,
                        translatedLabel: this.translations.filter_my,
                        label: "My courses"
                    },
                    
                    /*
                    {
                        filteringKey: "byNotEnrolled",
                        filteringFunction: this.filterCoursesByNotEnrolled,
                        filterAvailable: true,
                        translatedLabel: this.translations.not_enrolled,
                        label: "Not enrolled"
                    },
                    */

                    {
                        filteringKey: "byNew",
                        filteringFunction: this.filterCoursesByNew,
                        filterAvailable: true,
                        translatedLabel: this.translations.filter_newest,
                        label: "Newest"
                    },
                    {
                        filteringKey: "byPopular",
                        filteringFunction: this.sortCoursesByPopularity,
                        filterAvailable: true,
                        translatedLabel: this.translations.filter_popular,
                        label: "Popular"
                    },
                    {
                        filteringKey: "byFree",
                        filteringFunction: this.filterCoursesByFree,
                        filterAvailable: true,
                        translatedLabel: this.translations.free,
                        label: "Free"
                    },
                    {
                        filteringKey: "withCertificate",
                        filteringFunction: this.filterCoursesWithCertificate,
                        filterAvailable: true,
                        translatedLabel: this.translations.certificate,
                        label: "With certificate"
                    },
                    {
                        filteringKey: "byAuthor",
                        filteringFunction: this.filterCoursesByAuthor,
                        filterAvailable: this.courseAuthors().length,
                        translatedLabel: this.translations.filter_authors,
                        label: "By author",
                        dataSource: this.courseAuthors().map(authorData => {
                            if (authorData.name) {
                                return {
                                    label : authorData.name,
                                    value: authorData.name
                                }
                            }
                        }),
                    },
                    {
                        filteringKey: "byCategory",
                        filteringFunction: this.filterCoursesByCategory,
                        filterAvailable: this.courseCategories().length,
                        translatedLabel: this.translations.filter_categories,
                        label: "By category",
                        dataSource: this.courseCategories().map( categoryData => {
                            return {
                                label: categoryData.category,
                                value: categoryData.category
                            }
                        }),
                    },
                    {
                        filteringKey: "bySubscription",
                        filteringFunction: this.filterCoursesBySubscription,
                        filterAvailable: this.availableSubscriptions.length,
                        translatedLabel: this.translations.subscriptions,
                        label: "In subscription",
                        dataSource: this.availableSubscriptions.map( subscription => {
                            return {
                                label: subscription.title,
                                value: subscription.titleId,
                            }
                        })
                    },
                    {
                        filteringKey: "byBundle",
                        filteringFunction: this.filterCoursesByBundle,
                        filterAvailable: this.availableBundles.length,
                        translatedLabel: this.translations.bundles,
                        label: "In bundle",
                        dataSource: this.availableBundles.map( bundle => {
                            return {
                                label: bundle.title,
                                value: bundle.titleId
                            }
                        }),
                    },
                    {
                        filteringKey: "byCustomList",
                        filteringFunction: this.filterCoursesByCustomList,
                        filterAvailable: true,
                        label: "Custom list",
                        dataSource: this.availableCourses.map( course => {
                            return {
                                label: course.title,
                                value: course.titleId
                            }
                        })
                    },
                    {
                        filteringKey: "bySearchTerm",
                        filteringFunction: this.filterCoursesBySearchTerm,
                        filterAvailable: true,
                        label: "Search term"
                    }

                ]
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableCards.find(cardData => cardData.forSectionTemplates.includes(sectionTemplateId));
                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableCards[0] ? this.availableCards[0].cardFilename : "";
            },
            getDefaultCardsLoadOption () {
                return this.hasBundleOverviewSectionContext || this.hasSubscriptionOverviewSectionContext ? "load-all-cards" : "load-more";
            },
            getDefaultLimitAmountOfCards () {
                return !(this.hasBundleOverviewSectionContext || this.hasSubscriptionOverviewSectionContext);
            },
            hasBundleOverviewSectionContext () {
                return !!this.hasContext("bundle-overview-section");
            },
            hasSubscriptionOverviewSectionContext () {
                return !!this.hasContext("subscription-overview-section");
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    styles: null,
                    showFilters : true,
                    primaryFilterKey: '',
                    secondaryFilterKey: '',
                    disabledFilters: [],
                    showSlider : false,
                    appliedPromotion : "",
                    appliedCouponCode : "",
                    onClickAction : "toOverview" ,
                    openWithTarget : this.hasBundleOverviewSectionContext || this.hasSubscriptionOverviewSectionContext ? "new" : "default",
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 3, // how many cards will load on each page
                    limitAmountOfCards: this.getDefaultLimitAmountOfCards, // flag that enables pagination on cards rendering
                    cardsLoadOption: this.getDefaultCardsLoadOption,
                    itemVisibilitySettings: null
                }
            },
            translations () {
                return {
                    filter_all: this.$t('starting.filter_all'),
                    filter_my: this.$t('starting.filter_my'),
                    filter_newest: this.$t('starting.filter_newest'),
                    filter_popular: this.$t('starting.filter_popular'),
                    filter_categories: this.$t('starting.filter_categories'),
                    filter_authors: this.$t('starting.filter_authors'),
                    filter_search: this.$t('starting.filter_search'),
                    bundles: this.$t('common.bundles'),
                    subscriptions: this.$t('common.subscription'),
                    no_courses: this.$t('course.no_courses'),
                    continue: this.$t('course.continue'),
                    enroll: this.$t('common.enroll'),
                    not_enrolled: this.$t('common.not_enrolled'),
                    free: this.$t("common.free"),
                    access_until: this.$t('course.access_until'),
                    access_for: this.$t('course.access_for'),
                    you_save: this.$t('bundles.save'),
                    certificate: this.$t('course.certificate'),
                    course_offer: this.$t('common.course_offer'),
                    enrollment_closed: this.$t('course.enrollment_closed'),
                    coming_soon: this.$t('common.coming_soon'),
                    complete: this.$t('course.complete'),
                    price: this.$t('common.price')
                }
            },
            isSubscriptionOnly () {
                return this.subscriptionMode;
            },
            defaultPrimaryFilter () {
                if (this.hasSubscriptionOverviewSectionContext) {
                    return "bySubscription";
                }

                if (this.hasBundleOverviewSectionContext) {
                    return "byBundle";
                }

                return "byAll";
            },
            defaultSecondaryFilter () {
                if (this.hasBundleOverviewSectionContext) {
                    const bundleOverviewSectionState = this.findNodeState(this.hasContext("bundle-overview-section")[0].id);
                    return bundleOverviewSectionState ? bundleOverviewSectionState.selectedBundleId : '';
                } else if (this.hasSubscriptionOverviewSectionContext) {
                    const subscriptionOverviewSectionState = this.findNodeState(this.hasContext("subscription-overview-section")[0].id);
                    return subscriptionOverviewSectionState ? subscriptionOverviewSectionState.selectedSubscriptionId : '';
                }

                return '';

            },
            activePrimaryFilterKey () {
                if (this.myData && this.myData.primaryFilterKey) {
                    return this.myData.primaryFilterKey;
                }
                return this.defaultPrimaryFilter;

            },
            activeSecondaryFilterKey () {
                if (this.myData && this.myData.secondaryFilterKey) {
                    return this.myData.secondaryFilterKey;
                }
                return this.defaultSecondaryFilter;
            },
        },
        methods: {
            ...mapActions('products',[
                'loadProductPricesForCoupon'
            ]),
            renderComponent () {
                this.prepareDataToRender().then( courseData => { this.renderCourses(courseData) });
            },
            prepareDataToRender () {
                // treat all data manipulation as promises in order to handle manipulation that certainly need a promise to be applied
                return new Promise( (resolve,reject) => {
                    //all sync processes usually is here
                    let courses =  this.getCoursesDataCopy();


                    courses = courses.map((course) => {
                        return this.addExtraFields2(course);
                    });

                    // if (!this.isAdmin) {
                        courses  = this.removeCoursesThatShouldNotBeRendered(courses);
                    // }

                    resolve(this.applySelectedFilters(courses));
                }).then( coursesToRender => {
                    //handle async here
                    if (this.componentData.appliedCouponCode && this.componentData.onClickAction === "toCheckout") {
                        if (this.productPricesForCoupon[this.componentData.appliedCouponCode]) {
                            return new Promise ( resolve => {
                                resolve(this.applyCouponPrices(coursesToRender,this.productPricesForCoupon[this.componentData.appliedCouponCode]));
                            });
                        } else {
                            return this.loadProductPricesForCoupon( {
                                couponCode: this.componentData.appliedCouponCode,
                                productIds: coursesToRender.map( course => { return course.titleId }).join(",")
                            }).then( response => {
                                return this.applyCouponPrices(coursesToRender,response.data.products);
                            })
                        }
                    }

                    return coursesToRender;
                });
            },
            addExtraFields2 (course) {

                if (typeof course.me === "undefined") {
                    course.me = {};
                }

                if ( (course.status === "paid" && course.me.premium) ){
                    course.me.enrolled = true;
                } else if (course.status === "free" && course.me.registered) {
                    course.me.enrolled = true;
                } else {
                    course.me.enrolled = false;
                }

                if (course.authors && course.authors.length) {
                    course.authorName = course["authors"][0]["name"];
                    course.authorImage = course["authors"][0]["image"]['url'];

                    if (course.authorName && !course.authorImage) {
                        course.authorImage = this.imagePath + "/images/avatar-placeholder.jpg";
                    }
                }

                if (course.me &&  typeof course.me.courseProgress !== "undefined" && typeof course.me.courseProgress.unitsCompleted !== "undefined" && typeof course.me.courseProgress.unitsTotal !== "undefined") {
                    if (course.me.courseProgress.unitsTotal === 0 || course.me.courseProgress.unitsCompleted === 0) {
                        course.progressBarCompletion = 0;
                    } else {
                        course.progressBarCompletion = Math.floor( (course.me.courseProgress.unitsCompleted * 100 ) / course.me.courseProgress.unitsTotal);
                    }
                } else {
                    course.progressBarCompletion = 0;
                }

                if (course.me.expires && course.me.expires_t) {
                    course.me.expires = LWTranslate.formatTimestampLocalized(course.me.expires);
                }

                if (course.discountPrice) {
                    course.discount_percentage = this.calculateDiscountPercentage(course.price, course.discountPrice);
                }

                course.subscriptionOnly = this.isSubscriptionOnly;

                if (course.me.enrolled) {
                    course.buttonText = this.translations.continue;
                } else {
                    course.buttonText = this.translations.enroll;

                }
                if (this.enableHref) {
                    course.cardLink = this.createLinkForUser(course);
                } else {
                    course.cardLink = "javascript:void(0)";
                }
                course.translations = this.translations;
                // console.log("addExtraFields2 : " , course)

                course.buttonDisplay = true; // TODO: keeping it here for now. all cards have button except those that are in bundle overview section

                if (this.hasBundleOverviewSectionContext || this.hasSubscriptionOverviewSectionContext) {
                    // Showing initial course price rathen than discounted, since bundle initial price is calculated with course prices before any discount
                    course.discountFlag = false;
                    course.discountPrice = null;
                    course.discount_percentage = false;

                    // Hiding enroll button
                    course.buttonDisplay = false;
                }

                if (course.access === "private-enroll" && !course.me.enrolled) {
                    course.buttonDisplay = false;
                }

                if (course.access === "soon" && !course.me.enrolled) {
                    course.buttonDisplay = false;
                }

                return course;

            },
            createLinkForUser (course) {
                let cardClickAction = this.getCardClickAction();
                let urlParams = {"coursetitleid": course.titleId };

                if (typeof course.me !== 'undefined' && typeof course.me.last_video_id !== 'undefined' && course.me.last_video_id.length > 0) {
                    urlParams.unit = course.me.last_video_id;
                }

                let coursePageLink = wwwelopersUrl("course", urlParams);
                let pathPlayerLink = wwwelopersUrl("pathPlayer", urlParams);
                let paymentLink =   `/payment?product_id=${course.titleId}`;
                if (cardClickAction === 'toCheckout' && this.getAppliedCoupon()) {
                    paymentLink += `&coupon=${this.getAppliedCoupon()}`;
                }

                switch(cardClickAction) {
                    case "toCheckout":
                        if (course.me.enrolled) {
                            return pathPlayerLink;
                        }

                        if (['soon','private-enroll','private','view-locked'].includes(course.access)) {
                            return "javascript:void(0)";
                        }

                        //redirecting unenrolled users to pathPlayer enrolls them to course
                        if (course.status === "free") {
                            return pathPlayerLink;
                        }

                        return paymentLink;


                        break;
                    case "toOverview":

                        if (course.me.enrolled) {
                            return coursePageLink;
                        }

                        if (['soon','private','view-locked'].includes(course.access)) {
                            return "javascript:void(0)";
                        }

                        return coursePageLink;
                        break;
                    case "toPlayer":

                        if (course.me.enrolled) {
                            return pathPlayerLink;
                        }

                        if (['soon','private-enroll','private','view-locked'].includes(course.access)) {
                            return "javascript:void(0)";
                        }

                        if (course.status === "paid") {
                            return paymentLink;
                        }

                        return pathPlayerLink;

                        break;
                    default:
                        return coursePageLink;
                }
            },
            addExtraFields(course) {
                if (typeof course.me === "undefined") {
                    course.me = {};
                }

                if (course['premium']) {
                    course.me.showContinue = !!course.me.premium;
                } else {
                    course.me.showContinue = !!course.me.registered;
                }
                course.me.enrolled = course.me.showContinue;

                // course.continue = this.createLinkForEnrolledUser(course);

                course.canAccess = !!((!course.premium && course.me.registered) || (course.premium && course.me.premium));
                if (course["authors"] && course["authors"].length) {
                    course["authorName"] = course["authors"][0]["name"];
                    course["authorImage"] = course["authors"][0]["image"]['url_small'];
                }

                course.subscriptionOnly = this.isSubscriptionOnly;

                course.subscription = this.billing;

                if (course.me &&  typeof course.me.courseProgress !== "undefined" && typeof course.me.courseProgress.unitsCompleted !== "undefined" && typeof course.me.courseProgress.unitsTotal !== "undefined") {
                    if (course.me.courseProgress.unitsTotal === 0 || course.me.courseProgress.unitsCompleted === 0) {
                        course.progressBarCompletion = 0;
                    } else {
                        course.progressBarCompletion = Math.floor( (course.me.courseProgress.unitsCompleted * 100 ) / course.me.courseProgress.unitsTotal);
                    }
                } else {
                    course.progressBarCompletion = 0;
                }

                if (course.me.expires && course.me.expires_t) {
                    course.me.expires = LWTranslate.formatTimestampLocalized(course.me.expires);
                }

                if (course.discountPrice) {
                    course.discount_percentage = this.calculateDiscountPercentage(course.price, course.discountPrice);
                }

                course.buttonText = course.me.enrolled ?  this.translations.continue : this.translations.enroll;

                if (isMobile('app')) {
                    if (typeof this.mobileSettings['mobile_allow_purchase'] === "undefined" || ( typeof this.mobileSettings['mobile_allow_purchase'] !== "undefined" && !this.mobileSettings['mobile_allow_purchase']) ) {
                        if (course.status === "paid") {
                            course.allowedAppPurchases = false;
                        }
                    } else {
                        if (course.status === "paid") {
                            course.allowedAppPurchases = true;
                        }
                    }
                }

                course.showPriceAndButton = !course.hasOwnProperty('allowedAppPurchases') || course.allowedAppPurchases;
                course.translations = this.translations;

                return course;
            },
            createLinkForUnenrolledUser (course) {
                let cardClickAction = this.getCardClickAction();
                let urlParams = { "coursetitleid": course.titleId };

                switch(cardClickAction) {
                    case "toCheckout":
                        let url = `/payment?product_id=${course.id}`;

                        if (this.getAppliedCoupon()) {
                            url +=`&coupon=${this.getAppliedCoupon()}`;
                        }

                        return url;
                        break;
                    case "toOverview":
                        return wwwelopersUrl("course", urlParams);
                        break;
                    case "toPlayer":
                        return wwwelopersUrl("pathPlayer", urlParams);
                        break;
                }
            },
            createLinkForEnrolledUser(course) {
                // if(isMobile('app')) {
                //     return this.courseContinue === 'course' ? wwwelopersUrl("course", urlParams) : wwelopersUrl("pathPlayer", urlParams);
                // }
                let urlParams = { "coursetitleid": course.titleId };
                let cardClickAction = this.getCardClickAction();

                switch(cardClickAction) {
                    case "toCheckout":
                        return wwwelopersUrl("pathPlayer", urlParams);
                        break;
                    case "toOverview":
                        return wwwelopersUrl("course", urlParams);
                        break;
                    case "toPlayer":
                        return wwwelopersUrl("pathPlayer", urlParams);
                        break;
                }

                //
                // let urlParams = { "coursetitleid": course.titleId };
                // if (this.getCardClickAction() === 'toPlayer') {
                //     if (typeof course.me !== 'undefined' && typeof course.me.last_video_id !== 'undefined' && course.me.last_video_id.length > 0) {
                //         urlParams.unit = course.me.last_video_id;
                //     }
                //     return wwwelopersUrl("pathPlayer", urlParams);
                // } else {
                //     return wwwelopersUrl("course", urlParams);
                // }
            },

            applyCouponPrices (coursesToRender, newPrices) {
                return coursesToRender.map (course => {
                    if (newPrices && newPrices.hasOwnProperty(course.titleId)) {
                        course.discountFlag = true;
                        course.discountPrice = newPrices[course.titleId];
                        course.discount_percentage = this.calculateDiscountPercentage(course.price, course.discountPrice);
                    }

                    return course;
                })
            },

            calculateDiscountPercentage(price, discountPrice) {
                const discount = price - discountPrice;
                const discountPercentage = discount * 100 / price;

                return discountPercentage.toFixed(0);
            },
            loadMoreClicked () {},
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            removeCoursesThatShouldNotBeRendered(courses) {
                return courses.filter((course) => {
                    // if (course.access === "private-enroll" && !course.me.enrolled) {
                    //     return false;
                    // }

                    if (course.access === "view-locked" && !course.me.enrolled) {
                        return false;
                    }

                    if (course.access === "private") {
                        return false;
                    }


                    // If in After purchase remove enrolled courses
                    if( this.isAfterPurchasePage && !this.isAfterLoginPage && course.me.enrolled){
                        return false;
                    }

                    // Check Course Access in After Purchase and hide
                    if( this.isAfterPurchasePage && !this.isAfterLoginPage && course.access !== 'public'){
                        return false;
                    }

                    if (isMobile('app')) {
                        const doesNothaveAccessToCourse = !course.me.enrolled;

                        if (typeof this.mobileSettings == "undefined") {
                            return false;
                        }

                        if (typeof this.mobileSettings['mobile_display_free_courses'] === "undefined" || ( typeof this.mobileSettings['mobile_display_free_courses'] !== "undefined" && !this.mobileSettings['mobile_display_free_courses']) ) {
                            if (course.status === "free" && (!this.isLoggedIn || doesNothaveAccessToCourse)) {
                                return false;
                            }
                        }

                        if (typeof this.mobileSettings['mobile_display_paid_courses'] === "undefined" || ( typeof this.mobileSettings['mobile_display_paid_courses'] !== "undefined" && !this.mobileSettings['mobile_display_paid_courses']) ) {
                            if (course.status === "paid" && (!this.isLoggedIn || doesNothaveAccessToCourse)) {
                                return false;
                            }
                        }
                    }

                    return true;
                });
            },
            renderCourses (coursesToRender) {
                let amountOfCards = coursesToRender.length;
                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data : coursesToRender,
                    cardsPerRow: cardsPerPage,
                    amountOfCards
                };

                this.currentRenderData = renderData;

                if (coursesToRender.length === 0) {
                    return this.renderNoResultsMessage();
                }

                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    this.handleSliderCreation(renderData);
                    this.addCardListeners();
                    this.renderingCompleted(renderData);
                })
            },
            renderNoResultsMessage () {
                let renderData = {
                    template: 'nocontentmessage',
                    data: { content: "No results" }
                };

                let primaryKey = this.componentData.primaryFilterKey;

                if ( !this.isAdmin &&  ( !primaryKey || primaryKey === "byAll") ) {
                    renderData.data.content = this.translations.no_courses;
                } else if ( this.isAdmin &&  ( !primaryKey || primaryKey === "byAll") ) {
                    renderData.template = 'nocontentmessage_author_coursecards'
                    renderData.data.placeholderImageUrl = '/images/placeholders/courses.jpg';

                    renderData.data.content = 'There are no available courses yet.';

                    // Hide these for now TODO: enable them again after 1st release and fix link click
                    //renderData.data.link_content = 'Would you like to create one?';
                    //renderData.data.link = '/author/courses?create=new';
                }

                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    this.renderingCompleted(renderData);
                });
            },
            addCardListeners() {

            },
            getCoursesDataCopy () {
                return copyJson(this.courses);
            },
            applySelectedFilters (courses) {
                let primaryKey = this.activePrimaryFilterKey;
                let secondaryKey = this.activeSecondaryFilterKey;

                this.getFiltersConfig.find( filterData => {
                    if (primaryKey === filterData.filteringKey && filterData.filteringFunction ) {
                        // console.log("applySelectedFilters :" , primaryKey,secondaryKey)
                        courses = filterData.filteringFunction.call(null,courses,secondaryKey);
                        return true;
                    }
                })

                return courses;
            },
            filterCoursesBySearchTerm(courses, search) {
                search = search.toLowerCase();
                return courses.filter((course) => {
                    return course.title.toLowerCase().includes(search);
                });
            },

            filterCoursesByBundle (courses,filterKey) {
                return courses.filter( course => {
                    if(this.bundles){
                        for(var b=0; b < this.bundles.length ; b++){
                            if (this.bundles[b].titleId.toLowerCase().trim() === filterKey && this.bundles[b].courses) {
                                for (var c=0; c < this.bundles[b].courses.length ; c++){
                                    if(this.bundles[b].courses[c].product_id.toLowerCase().trim() == course.titleId.toLowerCase().trim() ){
                                        return course;
                                    }
                                }
                            }
                        }
                    }
                })
            },

            filterCoursesBySubscription (courses,filterKey) {
                return courses.filter( course => {
                    if(course.inProducts && ['public', 'private-enroll', 'soon'].indexOf(course.access) > -1){
                        for(var k=0; k < course.inProducts.subscriptions.length ; k++){
                            if(course.inProducts.subscriptions[k].toLowerCase().trim() == filterKey){
                                return course;
                            }
                        }
                    }
                })
            },

            sortCoursesByPopularity(courses) {
                return courses.filter( course => {
                    return this.isCourseAllowedToBeViewed(course);
                }).sort( (a,b) =>{
                    if (a.registeredUsers < b.registeredUsers) {
                        return 1;
                    }
                    else if (a.registeredUsers > b.registeredUsers)
                        return -1;
                    return 0;
                });
            },
            filterCoursesByMyCourses(courses) {
                return courses.filter( course => {
                    return course.me.enrolled;
                });
            },
            filterCoursesByNotEnrolled(courses) {
                return courses.filter( course => {
                    return !course.me || (course.me && !course.me.enrolled);
                });
            },
            filterCoursesWithCertificate(courses) {
                return courses.filter( course => {
                    return course.hasCertificate;
                });
            },
            filterCoursesByAuthor(courses, author) {
                return courses.filter( course => {
                    if (course.authors && course.authors.length && course.authors[0] && author && course.authors[0].name && course.authors[0].name === author) {
                        return course;
                    }
                });
            },

            filterCoursesByCategory(courses, category) {
                return courses.filter( course => {
                    return course.tags && category && course.tags.includes(category);
                });
            },

            filterCoursesByCustomList(courses, list) {
                return courses.filter((course) => {
                    return list.includes(course.titleId);
                });
            },
            filterCoursesByFree(courses) {
                return courses.filter( course => {
                    return course.status == 'free' && ( course.access == 'public' || course.access == 'private-enroll');
                });
            },
            filterCoursesByNew(courses) {
                return courses.filter( course => {
                    return this.isCourseAllowedToBeViewed(course);
                }).sort( (a,b) => {
                    if (a.created < b.created) {
                        return 1;
                    }

                    if (a.created > b.created) {
                        return -1;
                    }
                    return 0;
                });
            },
            isCourseAllowedToBeViewed (course) {
                return course.access == 'public' || course.access == 'private-enroll' || (course.access == "view-locked" && course.me.registered);
            },
        },
        watch : {
            "myData.cardType": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal ) {
                        // console.log(" 1 cardType newVal, oldVal: " , newVal, oldVal , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.cardsPerRow": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal ) {
                        // console.log("3 cardsPerRow newVal, oldVal: " , newVal, oldVal  , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.rows": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        // console.log("4 rows newVal, oldVal: " , newVal, oldVal  , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsLoadOption": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        // console.log("8 cardsLoadOption newVal, oldVal: " , newVal, oldVal  , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.appliedPromotion": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal ) {
                        // console.log("5 appliedPromotion newVal, oldVal: " , newVal, oldVal  , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }

                }
            },
            activePrimaryFilterKey: {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        // console.log(" 2 primaryFilterKey newVal, oldVal: " , newVal, oldVal , this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }

                }
            },
            activeSecondaryFilterKey: {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        // console.log("6 secondaryFilterKey " , newVal, oldVal  ,this.myId , copyJson(this.myData))
                        this.debouncedRenderComponent();
                    }

                }
            },
            "courses" : {
                deep: true,
                handler () {
                    //console.log(" 7 courses "  , this.myId)
                    // console.log("this.myData : " , copyJson(this.myData))
                    this.debouncedRenderComponent();
                }
            }
        },
    }
</script>
